const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evaluate - evaluate metaTagFieldOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const cacheKey = await sourceEvaluator(source.name);
  if (cacheKey === undefined) {
    return {};
  }
  const metaTagOptions = await sourceEvaluator({
    type: 'getCacheValueBehavior',
    name: cacheKey
  });
  const formTypeIdentifier = await sourceEvaluator(source.formTypeIdentifier);
  if (formTypeIdentifier === undefined) {
    return {};
  }
  if (metaTagOptions === null) {
    return {};
  }
  const [formTypeIdentifierKey] = Object.keys(formTypeIdentifier);
  const {
    children = {}
  } = metaTagOptions[formTypeIdentifierKey];
  return children;
};
module.exports = {
  evaluate
};